const BaseUrl = "https://food-shop-react-js.herokuapp.com";

export default BaseUrl;